export const originalProto = XMLHttpRequest.prototype
export const originalOpen = originalProto.open
export const originalSend = originalProto.send